import {get_devices, getNode_status, get_all_v, get_pages_config, get_three_config, get_geo_params} from '../api';
import {logout} from '../utils/plugin';

const mutations = {
    async update(state) {
        console.log('update')
        state.role = localStorage.getItem('role')
        state.username = localStorage.getItem('username')
        // 获取节点状态
        getNode_status().then(async (res) => {
            state.nodes = res.node_status.sort((a, b) => {
                if(a.status === b.status){
                    if(a.status === 'green'){
                        return 0
                    }
                } else if(a.status === 'gray') {
                    return 1
                } else {
                    return -1
                }
            });

            state.online_names = res.node_status.filter(function (x) {
                return x.status === 'green'
            }).map(function (x) {
                return x.value
            })

            state.offline_names = res.node_status.filter(function (x) {
                return x.status !== 'green'
            }).map(function (x) {
                return x.value
            })
            //节点名称的显示模式
            state.nodes_display = res.display
        })
        // {'devices_info': [{数据库里的所有字段}]}
        get_devices().then((res) => {
            let info = res.devices_info
            state.devices_info = info
            state.devices_pool = info.map(function (ele) {
                return {'id': ele.id}
            })
            state.devices_availble = info.filter(function (ele) {
                return ele.bind === false;
            }).map(function (ele) {
                return {'id': ele.id}
            })
            state.devices_stored = info.filter(function (ele) {
                return ele.bind === true;
            }).map(function (ele) {
                return {'id': ele.id}
            })
            state.pointData = info.map(function (ele) {
                return {'name': ele.name, 'value': 140, 'id': ele.id}
            })
            for(let i in info){
                state.pointCoor[info[i].name] = [info[i].longitude, info[i].latitude]
            }

            state.events = res.events
        })
        get_all_v().then((res) => {
            state.all_v = res
        })
        // 获取页面权限信息
        get_pages_config().then((res)=>{
            this.state.permission = res
        }).catch(error => {
            if (error.response && error.response.status === 401) {
                // 处理401错误
                console.error('Authentication required. Redirecting to login page...');
                logout()
                // 重定向到登录页等
            } else {
                // 处理其他错误
                console.log(error);
            }
        });

        // 获取三维页面权限信息
        get_three_config().then((res)=>{
            this.state.three = res
        }).catch(error => {
            if (error.response && error.response.status === 401) {
                // 处理401错误
                console.error('Authentication required. Redirecting to login page...');
                logout()
                // 重定向到登录页等
            } else {
                // 处理其他错误
                console.log(error);
            }
        });

        // 获取检波器的全局参数
        get_geo_params().then(res=>{
            state.geo_params = res
        }).catch(error => {
            if (error.response && error.response.status === 401) {
                // 处理401错误
                console.error('Authentication required. Redirecting to login page...');
                logout()
                // 重定向到登录页等
            } else {
                // 处理其他错误
                console.log(error);
            }
        });
    },
    update_m_v_unit(state, payload) {
        const indexToUpdate = payload.index;
        if (indexToUpdate >= 0 && indexToUpdate < state.m_v_unit.length) {
            const updatedArray = state.m_v_unit.slice(); // 创建副本
            updatedArray.splice(indexToUpdate, 1, payload.v_unit); // 修改副本
            state.m_v_unit = updatedArray; // 更新 state.m_v_unit
        } else {
            // 处理索引越界的情况
            console.error('索引越界或无效');
        }
    },
    update_last_time(state, last_time) {
        state.last_time = last_time
    },
    // 实时曲线参数重置
    reset_config(state) {
        state.fft_max = state.time_interval/2
        state.fft_min = 0
        state.fft = true
        state.amp_max = null
        state.amp_min = null
        state.time_last = 3
        state.v_unit = 0
    }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js